import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Typography,
} from '@execonline-inc/execonline-ui';
import { assertNever } from '@kofno/piper';
import { observer } from 'mobx-react';
import { T } from '../../../../../../../../../Translations';
import {
  ConfirmingCancelFromCreate,
  ConfirmingCancelFromPublish,
  ConfirmingCancelFromSaveAndEdit,
  Creating,
  Publishing,
  SaveAndEditing,
} from '../../../../../LearningCollectionPreviewStore/Types';
import { modalDescription } from '../../../../../Types';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  state:
    | Creating
    | SaveAndEditing
    | Publishing
    | ConfirmingCancelFromPublish
    | ConfirmingCancelFromCreate
    | ConfirmingCancelFromSaveAndEdit;
  onSave: () => void;
}

function OpenModal({ isOpen, onClose, state, onSave }: Props) {
  const action = (): 'Create' | 'Publish' | 'Save' => {
    switch (state.kind) {
      case 'creating':
      case 'confirming-cancel-from-create':
        return 'Create';
      case 'publishing':
      case 'confirming-cancel-from-publish':
        return 'Publish';
      case 'save-and-editing':
      case 'confirming-cancel-from-save-and-edit':
        return 'Save';
      default:
        assertNever(state);
    }
  };

  return (
    <Modal open={isOpen} onClose={onClose}>
      <ModalHeader className="w-full justify-between items-center">
        <Typography variant="subtitleLarge" fontWeight="semibold">
          <T kind={`${action()} this collection?`} />
        </Typography>
      </ModalHeader>
      <ModalBody>
        <Typography variant="bodyMedium">
          <T kind={modalDescription(action())} />
        </Typography>
      </ModalBody>
      <ModalFooter className="flex-row justify-end">
        <Button
          variant="text"
          color="secondary"
          onClick={onClose}
          data-intercom-target="modal-cancel-button"
        >
          <T kind="Cancel" />
        </Button>
        <Button onClick={onSave} data-intercom-target="modal-save-collection-button">
          <T kind={`${action()} Collection`} />
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default observer(OpenModal);
